import { Button, Panel } from '@ixicare/ui';
import * as React from 'react';
import styles from './DrawToolSidebar.module.css';
import { t } from '~i18n';

interface DrawToolSidebarProps {
  name: string;
  floorNumber: string;
  isCreate: boolean;
  handleToggleCreate: (shouldCreate?: boolean) => void;
  children: React.ReactNode;
}

const DrawToolSidebar = ({ name, floorNumber, isCreate, children, handleToggleCreate }: DrawToolSidebarProps) => {
  return (
    <div className={styles.DrawToolSidebar}>
      <div className={styles.DrawToolHeader}>
        <Panel.Title>{t('drawtool.sidepanel.title')}</Panel.Title>
        <Panel.Right>{name}</Panel.Right>
        <Panel.Subtitle>{floorNumber}</Panel.Subtitle>
        {!isCreate && (
          <div className="mb-20">
            <Button onClick={() => handleToggleCreate(true)}>{t('drawtool.sidepanel.button.start')}</Button>
          </div>
        )}
        {isCreate && (
          <div className="mb-20">
            <Button buttonType="error" onClick={() => handleToggleCreate(false)}>
              {t('drawtool.sidepanel.button.cancel')}
            </Button>
          </div>
        )}
      </div>
      {children}
    </div>
  );
};

export default DrawToolSidebar;
